"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCodeExist = checkCodeExist;
exports.createRes = createRes;
exports.deleteRes = deleteRes;
exports.dynamicTree = dynamicTree;
exports.getResInfo = getResInfo;
exports.queryMenuResPage = queryMenuResPage;
exports.updateRes = updateRes;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
//菜单资源
function queryMenuResPage(query) {
  return (0, _requestAuth.default)({
    url: '/sysMenuRes/page',
    method: 'get',
    params: query
  });
}

// 新增
function createRes(data) {
  return (0, _requestAuth.default)({
    url: '/sysMenuRes',
    method: 'post',
    data: data
  });
}

// 通过ID查询
function getResInfo(id) {
  return (0, _requestAuth.default)({
    url: '/sysMenuRes/' + id,
    method: 'get'
  });
}

// 更新
function updateRes(data) {
  return (0, _requestAuth.default)({
    url: '/sysMenuRes',
    method: 'put',
    data: data
  });
}

// 删除
function deleteRes(resId) {
  return (0, _requestAuth.default)({
    url: '/sysMenuRes/' + resId,
    method: 'delete'
  });
}

/**
 * 获取资源树
 */
function dynamicTree(query) {
  return (0, _requestAuth.default)({
    url: '/sysMenuRes/tree',
    method: 'get',
    params: query
  });
}

//code是否存在
function checkCodeExist(code, resId) {
  var query = {
    "code": code,
    "resId": resId
  };
  return (0, _requestAuth.default)({
    url: '/sysMenuRes/checkCodeExist',
    method: 'get',
    params: query
  });
}